<template>
    <v-dialog
        v-model="isDialogOpen"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
    >
        <v-card>
            <v-toolbar
                dark
                color="teal"
                class="px-3"
            >
                <v-toolbar-title>
                    <span class="font-weight-bold">{{ headerTitle }}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                        icon
                        dark
                        @click.native="$emit('close')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container>
                <v-form
                    ref="form"
                    v-model="formValid"
                >
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="formData.valueNameRu"
                                :label="$t('nameRu')"
                                :rules="[value => !!value || this.$t('requiredField')]"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                v-model="formData.valueNameUa"
                                :label="$t('nameUa')"
                                :rules="[value => !!value || this.$t('requiredField')]"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <attribute-category-item
                        @attributeChanged="setRelation"
                        @categoriesChanged="setRelation"
                        v-for="(item, idx) in formData.relations"
                        :key="idx"
                        :index="idx"
                        :relation="item"
                        :attributes-categories="attributesCategories"
                        :is-unique="isUniqueAttribute(item.attributeId)"
                        :is-single="formData.relations.length <= 1"
                        @remove="removeRelation"
                        @set-relation="setRelation"
                    ></attribute-category-item>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                @click="addRelation"
                            >
                                <span>{{ $t('add') }}&nbsp;{{ $t('attribute') }}</span>
                            </v-btn>
                            <v-btn
                                depressed
                                class="white--text teal"
                                width="130"
                                :disabled="!formValid"
                                @click="validate"
                            >
                                <span>{{ $t('save') }}</span>
                            </v-btn>

                        </v-col>
                    </v-row>

                </v-form>
            </v-container>
        </v-card>
    </v-dialog>
</template>


<script>
import AttributeCategoryItem from "./AttributeCategoryItem";
import { MixinDialogRemote } from '../../../mixins';
import {AttributesService, InfoService} from "../../../services";

export default {
    name: "EnumAttributeValueFullscreenDialog",
    components: { AttributeCategoryItem },
    mixins: [ MixinDialogRemote ],
    props: [ 'dialogType', 'attributeValueID' ],
    data () {
        return {
            formValid: false,
            attributeId: null,
            formData: {
                valueNameRu: null,
                valueNameUa: null,
                relations: [
                    {
                        attributeId: null,
                        categoryIDs: []
                    }
                ]
            },
            attributesCategories: [],
        }
    },
    computed: {
        headerTitle() {
            return `${this.$t(this.dialogType)} ${this.$t('attributeValue').toLowerCase()}`;
        }
    },
    watch: {
        isDialogOpen(value) {
            if (value) {
                this.resetForm();
                this.setAttributesWithCategories();
                if(this.dialogType === 'edit') {
                    this.setInitialData();
                }
            }
        },
    },
    methods: {
        addRelation() {
            this.formData.relations.push({
                attributeId: null,
                categoryIDs: []
            });
        },
        removeRelation(idx) {
            this.formData.relations.splice(idx, 1);
        },
        setRelation(data) {
            this.$set(this.formData.relations, data.idx, data.relation)
        },
        isUniqueAttribute(attributeId) {
            const notUniqueIDs = this.formData.relations.filter(item => {
                return item.attributeId === attributeId
            })
            return notUniqueIDs.length <= 1
        },
        setAttributesWithCategories() {
            InfoService.setAuth(this.$store.getters.token);
            InfoService.getAttributesWithCategories()
                .then(res => {
                    this.attributesCategories = res.data;
                })
                .catch(err => {
                    console.log(err);
                })

        },
        setInitialData() {
            AttributesService.setAuth(this.$store.getters.token);
            AttributesService.getAttributeValue(this.attributeValueID)
                .then(res => {
                    this.formData = {
                        valueNameRu: res.data.valueNameRu,
                        valueNameUa: res.data.valueNameUa,
                        relations: res.data.relations
                    }
                })
                .catch(err => {
                    console.log(err);
                })
        },
        resetForm() {
            this.formData = {
                valueNameRu: null,
                valueNameUa: null,
                relations: [
                    {
                        attributeId: null,
                        categoryIDs: []
                    }
                ]
            };
        },
        validate() {
            if (this.$refs.form.validate()) {
                const params = {...this.formData};
                if (this.dialogType === 'edit') this.$set(params, 'id', this.attributeValueID);
                this.$emit('validated', params);
            }
        }
    }
}
</script>

<style scoped>

</style>
